import type {
    AnatomyBinding,
    AnatomyPart,
    AnatomyState,
    AnatomyVariant,
    ComponentAnatomySpec,
} from "./componentAnatomy";
import { anatomyTextStyle } from "./componentAnatomyText";

const parts: readonly AnatomyPart[] = [
    {
        id: "background",
        label: "Root",
        element: "transparent stretching .root column and --field-gap",
    },
    {
        id: "label",
        label: "Label",
        element: ".label element wrapping the label text",
    },
    {
        id: "optional",
        label: "Optional suffix",
        element: ".optional inside the .label element",
    },
    {
        id: "glyph",
        label: "Tooltip glyph",
        element: "16px InfoIcon in the sibling .labelTooltip button",
    },
    {
        id: "border",
        label: "Control boundary",
        element: "child-owned control surface, not styled by Field",
    },
    {
        id: "message",
        label: "Message",
        element: ".message used by Description or Error",
    },
];

const states: readonly AnatomyState[] = [
    { id: "resting", label: "Default", selector: "" },
    { id: "invalid", label: "Invalid", selector: "[data-invalid]" },
];

const sharedBindings: readonly AnatomyBinding[] = [
    {
        partId: "background",
        property: "gap",
        token: "--space-4",
        via: "--field-gap",
    },
    ...anatomyTextStyle({
        scale: "xs",
        weight: "400",
        mixin: "text-xs-12-regular",
    }),
    ...anatomyTextStyle({
        scale: "xs",
        weight: "400",
        mixin: "text-xs-12-regular",
        partId: "message",
    }),
    { partId: "glyph", property: "width", literal: "16px" },
    { partId: "glyph", property: "height", literal: "16px" },
    {
        partId: "border",
        property: "height",
        literal: "28px",
        note: "The schematic uses the Figma md Input. Field does not own control height.",
    },
];

const variants: readonly AnatomyVariant[] = [
    {
        id: "default",
        label: "Default",
        selector: "",
        restingBindings: [
            {
                partId: "label",
                property: "color",
                token: "--fg-secondary",
                via: "--field-label-fg",
            },
            {
                partId: "optional",
                property: "color",
                token: "--fg-tertiary",
            },
            {
                partId: "glyph",
                property: "color",
                token: "--fg-secondary",
                via: "--field-label-fg",
            },
            {
                partId: "message",
                property: "color",
                token: "--fg-secondary",
                via: "--field-message-fg",
            },
        ],
        stateBindings: {
            invalid: [
                {
                    partId: "message",
                    property: "color",
                    token: "--fg-error",
                    note: "Error message only; the label and tip stay secondary.",
                },
            ],
        },
    },
];

export const fieldAnatomy: ComponentAnatomySpec = {
    label: "Field",
    schematic: "field",
    rootSelector: ".root",
    variantAxisLabel: "Variant",
    parts,
    states,
    sharedBindings,
    variants,
};
